import { gql } from "@apollo/client";

export const BULK_PRINT_OFFERS = gql`
  mutation bulkPrintOffers($input: BulkPrintOffersInput) {
    bulkPrintOffers(input: $input) {
      correlationId
    }
  }
`;
